import React, { ReactNode, useMemo } from "react";
import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { websiteBuilderGenerateDefaultImage, IWebsiteBuilderImage } from "../../../../../nodes/element/websiteBuilderImage";
import { websiteBuilderGenerateDefaultVideo, IWebsiteBuilderVideo } from "../../../../../nodes/element/websiteBuilderVideo";
import { isWebsiteBuilderImageAllowedFileSubtype, isWebsiteBuilderVideoAllowedFileSubtype } from "../../../../../utility/websiteBuilderAllowedMedia";
import { DraggableNode } from "../../draggableNode/DraggableNode";

interface IMediaDraggableProps {
  mediaItem: IWebsiteBuilderMediaItem;
  children: ReactNode;
}

export function MediaDraggable(props: IMediaDraggableProps) {
  const { mediaItem, children } = props;

  const item: IWebsiteBuilderImage | IWebsiteBuilderVideo = useMemo(() => {
    if (isWebsiteBuilderImageAllowedFileSubtype(mediaItem.subtype)) {
      return websiteBuilderGenerateDefaultImage(mediaItem.id, mediaItem.source);
    } else if (isWebsiteBuilderVideoAllowedFileSubtype(mediaItem.subtype)) {
      return websiteBuilderGenerateDefaultVideo(mediaItem.id, mediaItem.source);
    } else {
      return null;
    }
  }, [mediaItem.subtype, mediaItem.id, mediaItem.source]);

  if (item == null) {
    return null;
  }

  return (
    <DraggableNode item={item}>
      {children}
    </DraggableNode>
  );
}
